(($) => {
  const initHoverBoxes = () => {
    const $firstColumn = $('body.home .home-featured-posts-area > article:nth-child(1)');
    const $column = $('body.home .home-featured-posts-area > article');

    $column.on('mouseenter', (e) => {
      $column.css('width', '25%');
      const parent = $(e.target).parents('article');
      $(parent).css('width', '50%');
    });

    $column.on('mouseleave', () => {
      $column.css('width', '25%');
      $firstColumn.css('width', '50%');
    });
  };

  $(document).on('ready', () => {
    initHoverBoxes();
  });
})(jQuery);
